// Shared group media shape: iOS stores data URLs for photos and HTTPS GIF URLs.
export function groupChatMessage(event) {
  const data=event.data||{};
  const imageData=typeof data.imageData==="string"&&/^data:image\/(?:jpeg|png|gif|webp);base64,/i.test(data.imageData)?data.imageData:null;
  const gifUrl=typeof data.gifUrl==="string"&&/^https:\/\//i.test(data.gifUrl)?data.gifUrl:null;
  return {id:event.id,from:event.email,name:event.name,text:data.text||data.msg||"",imageData,gifUrl,ts:event.created_at};
}

export function mergeWarHistory(local,incoming) {
  const weeks=new Map();
  for(const row of [...(Array.isArray(local)?local:[]),...(Array.isArray(incoming)?incoming:[])]){
    if(!row||!Number.isInteger(row.weekIdx)||typeof row.warId!=="string"||!row.warId||typeof row.warName!=="string"||
      !Number.isInteger(row.myVal)||row.myVal<0||!Number.isInteger(row.target)||row.target<=0||typeof row.date!=="string")continue;
    const prior=weeks.get(row.weekIdx);
    if(!prior||row.myVal>prior.myVal)weeks.set(row.weekIdx,row);
  }
  return [...weeks.values()].sort((a,b)=>a.weekIdx-b.weekIdx).slice(-52);
}

export function warStateForWire(storage) {
  const war_history=mergeWarHistory([],storage.get("ft-war-history"));
  const war_claimed_weeks=[...new Set([...(Array.isArray(storage.get("ft-war-claimed-weeks"))?storage.get("ft-war-claimed-weeks"):[]),...war_history.map(w=>w.weekIdx)])]
    .filter(Number.isInteger).sort((a,b)=>a-b);
  return {war_history,war_claimed_weeks};
}

export function restoreWarState(storage,incoming,{mergeLocal=true}={}) {
  if(!incoming||(!Array.isArray(incoming.war_history)&&!Array.isArray(incoming.war_claimed_weeks)))return;
  if(!mergeLocal){
    warStateForWire(storage).war_claimed_weeks.forEach(week=>storage.set(`ft-war-claimed-${week}`,false));
    storage.set("ft-last-war-win-idx",null);
  }
  const local=mergeLocal?warStateForWire(storage):{war_history:[],war_claimed_weeks:[]};
  const history=mergeWarHistory(local.war_history,incoming.war_history);
  const weeks=[...new Set([...local.war_claimed_weeks,...(Array.isArray(incoming.war_claimed_weeks)?incoming.war_claimed_weeks:[]),...history.map(w=>w.weekIdx)])]
    .filter(Number.isInteger).sort((a,b)=>a-b);
  storage.set("ft-war-history",history);
  storage.set("ft-war-claimed-weeks",weeks);
  weeks.forEach(week=>storage.set(`ft-war-claimed-${week}`,true));
  if(weeks.length)storage.set("ft-last-war-win-idx",weeks.at(-1));
  globalThis.window?.dispatchEvent(new Event("ironlog:war-state"));
}

// Match native challenge snapshots: strengths and volume always travel in lbs.
export const socialWeightLbs=(value,units)=>units==="kg"?Math.round(value*2.2046226218487757*10)/10:value;
export const socialVolumeLbs=(value,units)=>Math.round(socialWeightLbs(value,units));
export function sharedGroupValue(state,metric,{since,streak=0}) {
  const workouts=(state.workouts||[]).filter(w=>w.date>=since);
  if(metric==="streak")return streak;
  if(metric==="workouts")return workouts.length;
  if(metric==="protein")return (state.nutrition||[]).filter(n=>n.date>=since&&(n.protein||0)>=(state.goals?.protein||180)).length;
  if(metric==="volume")return socialVolumeLbs(workouts.reduce((sum,w)=>sum+(w.exercises||[]).reduce((a,e)=>a+(e.sets||[]).reduce((b,s)=>b+(parseFloat(s.weight)||0)*(parseInt(s.reps)||0),0),0),0),state.units);
  return 0;
}
export function warClaimed(storage,week) {
  return !!storage.get(`ft-war-claimed-${week}`)||warStateForWire(storage).war_claimed_weeks.includes(week);
}
export function subscribeWarClaim(storage,week,changed,target=globalThis.window) {
  const refresh=()=>changed(warClaimed(storage,week));
  refresh();
  target?.addEventListener("ironlog:war-state",refresh);
  target?.addEventListener("storage",refresh);
  return ()=>{target?.removeEventListener("ironlog:war-state",refresh);target?.removeEventListener("storage",refresh);};
}
